/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(() => {
  const targetHandles = new Set([
    'jig-of-the-month-club-3-months-prepaid',
    'jig-of-the-month-club-12-months-prepaid'
  ]);

  const productMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = productMatch ? productMatch[1] : '';

  if (!targetHandles.has(handle)) return;

  const dataElement = document.querySelector('form[id^="product-form-main-"] [data-prepaid-price-data]');
  if (!dataElement) return;

  const form = dataElement.closest('form');
  const priceData = JSON.parse(dataElement.textContent);
  let selectedId = String(priceData.selected);
  let priceRoot;
  const observerOptions = { childList: true, characterData: true, subtree: true };

  function selectedPrice() {
    // Use Shopify's presentment-currency allocation, never a base-price override
    // of a legitimate selling-plan discount. Unknown/ambiguous plans fail closed.
    if (priceData.currency !== (window.Shopify?.currency?.active || 'USD')) return;
    const variant = priceData.variants[selectedId];
    if (!variant) return;
    const planIds = new Set(Array.from(form.elements)
      .filter(input => input.name === 'selling_plan' && !input.disabled &&
        (!['radio', 'checkbox'].includes(input.type) || input.checked))
      .map(input => input.value).filter(Boolean));
    if (planIds.size > 1) return;
    const planId = Array.from(planIds)[0];
    return planId ? variant.plans[planId] : variant.price;
  }

  function formatVariantPrice(variant) {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    }).format(variant.price / 100);

    return window.theme?.currencyCodeEnabled
      ? `${formatted} ${currency}`
      : formatted;
  }

  function updateMainPrice() {
    const price = selectedPrice();
    if (!Number.isFinite(price)) return;
    const priceElement = priceRoot?.querySelector('.price-list > .price:not(.price--compare)');
    if (!priceElement) return;
    const formattedPrice = formatVariantPrice({ price });
    const visibleText = Array.from(priceElement.childNodes)
      .filter(node => node.nodeType !== 1 || !node.matches('.visually-hidden, .sr-only'))
      .map(node => node.textContent).join('').trim();
    if (visibleText === formattedPrice) return;

    const accessibleLabel = priceElement
      .querySelector('.visually-hidden, .sr-only')
      ?.cloneNode(true);

    // Do not observe our own write, and leave Recharge's element/classes intact.
    priceObserver.disconnect();
    priceElement.replaceChildren();

    if (accessibleLabel) {
      priceElement.appendChild(accessibleLabel);
    }

    priceElement.appendChild(
      document.createTextNode(formattedPrice)
    );
    priceObserver.observe(priceRoot, observerOptions);
  }

  const priceObserver = new MutationObserver(updateMainPrice);

  function bindPriceRoot() {
    // Warehouse replaces this block on variant changes. Recharge can then replace
    // its price descendants later, beyond the existing 50/250ms fallback updates.
    const nextRoot = form.querySelector('.product-form__info-list .price-list')?.parentElement;
    if (nextRoot !== priceRoot) {
      priceObserver.disconnect();
      priceRoot = nextRoot;
      if (priceRoot) priceObserver.observe(priceRoot, observerOptions);
    }
    updateMainPrice();
  }

  form.addEventListener('variant:changed', (event) => {
    const variant = event.detail?.variant;

    if (!variant) return;
    selectedId = String(variant.id);
    updateMainPrice();
    // Always read the latest selection; rapid changes must not restore old prices.
    window.setTimeout(bindPriceRoot, 50);
    window.setTimeout(bindPriceRoot, 250);
  });

  form.addEventListener('product:rerender', () => queueMicrotask(bindPriceRoot));
  form.addEventListener('change', event => {
    if (event.target.name === 'selling_plan') queueMicrotask(bindPriceRoot);
  });
  bindPriceRoot();
})();
